import { ContentTypeView, InputWrapper, Wrapper, DragAndDropSortable } from "nystem-components";

const ReferenceSortable = ({ model, view, value = [], setValue, path }) => {
  value = value instanceof Array ? value : [value];
  const { renderFormat, className, source, itemClassName } = model;

  const option = (item) => ({
    key: item,
    noForm: true,
    contentType: source,
    baseView: view,
    format: renderFormat || "view",
    id: item,
    params: view.params,
    className: itemClassName,
    onReference: (item) => view.event(item.event, { ...item, model, path }),
  });

  // A single reference has nothing to sort.
  const items =
    model.limit === 1 ? (
      value.map((item) => {
        const { key, ...props } = option(item);
        return <ContentTypeView key={key} {...props} />;
      })
    ) : (
      <DragAndDropSortable Component={ContentTypeView} items={value.map(option)} setValue={setValue} />
    );

  if (model.wrapper) return <InputWrapper model={model}>{items}</InputWrapper>;

  return <Wrapper className={className}>{items}</Wrapper>;
};
export default ReferenceSortable;
